const grabScrollContainer = document.querySelector(
	'.grab-scroll-testimony-container',
);
const sliderArrows = document.querySelector('.testimony-arrows');
const swiperPaginationBullet = document.querySelectorAll(
	'.swiper-pagination-bullet',
);
const leftArrow = document.getElementById('testimony-left-arrow');
const rightArrow = document.getElementById('testimony-right-arrow');
let sliderCounter = 0;
let sliding = false;

if (grabScrollContainer) {
	if (sliderArrows) {
		grabScrollContainer.addEventListener('scroll', () => {
			const isAtLeftEnd = grabScrollContainer.scrollLeft <= 0;
			const isAtRightEnd =
				grabScrollContainer.scrollLeft + grabScrollContainer.clientWidth + 1 >=
				grabScrollContainer.scrollWidth;

			leftArrow.setAttribute('fill', isAtLeftEnd ? '#42595A1F' : '#62625F');

			rightArrow.setAttribute('fill', isAtRightEnd ? '#42595A1F' : '#62625F');

			swiperPaginationBullet.forEach((bullet, index) => {
				bullet.classList.remove('bg-gray-medium');
				bullet.classList.add('opacity-50');
				if (index === sliderCounter) {
					bullet.classList.remove('bg-transparent');
					bullet.classList.remove('opacity-50');
					bullet.classList.add('bg-gray-medium');
				}
			});
		});

		leftArrow.addEventListener('click', () => {
			if (sliding) {
				return;
			}
			sliding = true;
			if (sliderCounter > 0) {
				sliderCounter--;
			}
			grabScrollContainer.scrollBy({
				left: -grabScrollContainer.offsetWidth,
				behavior: 'smooth',
			});
			setTimeout(() => {
				sliding = false;
			}, 700);
		});

		rightArrow.addEventListener('click', () => {
			if (sliding) {
				return;
			}
			sliding = true;
			if (sliderCounter < swiperPaginationBullet.length - 1) {
				sliderCounter++;
			}
			grabScrollContainer.scrollBy({
				left: grabScrollContainer.offsetWidth,
				behavior: 'smooth',
			});

			setTimeout(() => {
				sliding = false;
			}, 700);
		});
	}
	if (swiperPaginationBullet) {
		swiperPaginationBullet.forEach((bullet, index) => {
			bullet.classList.remove('bg-gray-medium');
			bullet.classList.add('opacity-50');
			if (index === sliderCounter) {
				bullet.classList.remove('bg-transparent');
				bullet.classList.remove('opacity-50');
				bullet.classList.add('bg-gray-medium');
			}
			bullet.addEventListener('click', () => {
				if (sliding) {
					return;
				}
				sliding = true;
				let scrollAmount;
				if (index === 0 && sliderCounter === 0) {
					scrollAmount = grabScrollContainer.clientWidth * index;
				} else if (index > sliderCounter) {
					scrollAmount =
						grabScrollContainer.clientWidth * (index - sliderCounter);
					sliderCounter = index;

					grabScrollContainer.scrollBy({
						left: scrollAmount,
						behavior: 'smooth',
					});
				} else if (index < sliderCounter) {
					scrollAmount =
						grabScrollContainer.clientWidth * (sliderCounter - index);
					sliderCounter = index;
					grabScrollContainer.scrollBy({
						left: -scrollAmount,
						behavior: 'smooth',
					});
				}
				setTimeout(() => {
					sliding = false;
				}, 700);
			});
		});
	}
}

export default grabScrollContainer;
